<div class="reference-date-filter-origin" [class.is-global]="variant() === 'global'">
	<mat-icon class="reference-date-filter-prefix">calendar_month</mat-icon>
	<button
		type="button"
		class="th-filter-input reference-date-filter-trigger"
		[class.is-filtered]="hasValue()"
		[class.is-invalid]="invalid()"
		[disabled]="disabled()"
		[attr.aria-label]="'database_view.reference_date.label' | transloco"
		[attr.aria-invalid]="invalid()"
		[attr.title]="displayValue()"
		(click)="onTriggerClick()"
	>
		{{
			hasValue()
				? ('database_view.reference_date.selected' | transloco: { date: displayValue() })
				: ('database_view.reference_date.placeholder' | transloco)
		}}
	</button>
	@if (showClear()) {
		<button
			matIconButton
			type="button"
			class="reference-date-filter-clear"
			[attr.aria-label]="'database_view.reference_date.clear' | transloco"
			(click)="clear($event)"
		>
			<mat-icon>close</mat-icon>
		</button>
	}
	@if (variant() === 'global') {
		<input
			class="reference-date-filter-anchor"
			tabindex="-1"
			aria-hidden="true"
			[matDatepicker]="picker"
			[max]="maxDate"
			[value]="value()"
			(dateChange)="onDateChange($event.value)"
		/>
		<mat-datepicker #picker></mat-datepicker>
	}
</div>
